import React, { useEffect, useState } from 'react'
import {Link} from "react-router-dom";
import TopSubmenu from "~/Admin/Layout/TopSubmenu/TopSubmenu";
import {connect} from "react-redux";
import {adminHttp} from "~/Admin/services/http";
import Moment from "react-moment";
import Pagination from "react-js-pagination";
import classnames from "classnames";
import {toggleArray} from "~/services/helpers";
import {Form} from "react-bootstrap";
import PopupActions from '../../../Components/PopupActions/PopupActions';
import ConfirmedButton from "~/Components/ConfirmedButton/ConfirmedButton";
import {ChevronRight} from "~/Components/Icons/Icons";

const AdminRegistration = ({match, event, ...props}) => {

    const defaultFilters = {
        filter: '',
        wave_id: '',
        package_id: '',
        registration_status: '',
    };

    const [response, setResponse] = useState({});
    const [filters, setFilters] = useState(defaultFilters);
    const [meta, setMeta] = useState({});
    const [selected, setSelected] = useState([]);
    const [waves, setWaves] = useState([]);
    const [packages, setPackages] = useState([]);
    const [regStatuses, setRegStatuses] = useState([
        'pending', 'in_progress', 'submitted', 'declined'
    ]);

    const handleFilter = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        let filterData = {...filters, [name]: value};

        setFilters(filterData);
    };

    const customTargetObject = (name, value) => {
        return (
            {target: {
                name,
                value
            }
        })
    }

    const loadMeta = () => {
        adminHttp
            .get(`/events/${event.id}/invitations/meta`)
            .then(res => setMeta(res.data));
    };

    const loadData = (page = 1) => {
        const endpoint = `/events/${event.id}/invitations`;
        adminHttp
            .get(`${endpoint}?${new URLSearchParams({...filters, page}).toString()}`)
            .then(res => {
                setResponse(res.data);
            });
    };

    const loadWaves = () => {
        adminHttp
            .get(`/events/${event.id}/waves`)
            .then(res => setWaves(res.data));
    };

    const loadPackages = () => {
        adminHttp
            .get(`/events/${event.id}/packages`)
            .then(res => setPackages(res.data));
    };

    useEffect(loadMeta, [event]);
    useEffect(loadData, [filters, event]);

    useEffect(() => {
        loadWaves();
        loadPackages();
    }, [])

    const handleSelectedChange = (id) => {
        setSelected(toggleArray(selected, id));
    };

    const sendPreEvent = () => {
        adminHttp
            .post(`/events/${event.id}/invitations/send-pre-event`, {
                'ids': selected
            })
            .then(res => {
                setSelected([]);
                loadMeta();
                loadData();
            });
    };

    const sendSurveys = () => {
        adminHttp
            .post(`/events/${event.id}/invitations/send-event-survey`, {
                'ids': selected
            })
            .then(res => {
                setSelected([]);
                loadMeta();
                loadData();
            });
    };

    return (
        <>
            <div className="data-uploads">
                <div className="row">
                    <div className="col-8">
                        <h2>Registration Management</h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <TopSubmenu>
                            <a href="#" onClick={e => handleFilter(customTargetObject("filter", ''))}
                               className={classnames({'active' : filters.filter === ''})}>All Registrations ({meta.all})</a>

                            <a href="#" onClick={e => handleFilter(customTargetObject("filter", 'reg_pending'))}
                               className={classnames({'active' : filters.filter === 'reg_pending'})}>Registration Pending ({meta.reg_pending})</a>

                            <a href="#" onClick={e => handleFilter(customTargetObject("filter", 'reg_progress'))}
                               className={classnames({'active' : filters.filter === 'reg_progress'})}>Registration In Progress ({meta.reg_progress})</a>

                            <a href="#" onClick={e => handleFilter(customTargetObject("filter", 'reg_submitted'))}
                               className={classnames({'active' : filters.filter === 'reg_submitted'})}>Registration Submitted ({meta.reg_submitted})</a>
                        </TopSubmenu>
                    </div>

                    <div className="col-12">
                        <div className="inline-filters">
                            <label className="text-muted text-uppercase">Filters</label>
                            <select
                                name="wave_id"
                                defaultValue={filters.wave_id}
                                onChange={handleFilter}
                                className="form-control"
                            >
                                <option value={''}>Wave</option>

                                {waves.map((wave) => (
                                    <option key={wave.id} value={wave.id}>
                                        {wave.name}
                                    </option>
                                ))}
                            </select>

                            <select
                                name="package_id"
                                defaultValue={filters.package_id}
                                onChange={handleFilter}
                                className="form-control"
                            >
                                <option value={''}>Package</option>

                                {packages.map((p) => (
                                    <option key={p.id} value={p.id}>
                                        {p.name}
                                    </option>
                                ))}
                            </select>

                            <select
                                name="registration_status"
                                defaultValue={filters.registration_status}
                                onChange={handleFilter}
                                className="form-control"
                            >
                                <option value={''}>Registration Status</option>

                                {regStatuses.map((status) => (
                                    <option key={status} value={status}>
                                        {status}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-12">
                        <div className="card shadow-sm bg-white mt-3">
                            <div className="card-body">
                                <div className="table-scrollable">
                                    <table className="table">
                                        <thead>
                                        <tr>
                                            {['reg_submitted'].includes(filters.filter) && <th scope="col">#</th>}

                                            <th scope="col">Guest Name</th>
                                            <th scope="col">Guest Email</th>
                                            <th scope="col">Invitees</th>
                                            <th scope="col">Wave/Package</th>

                                            {filters.filter === 'reg_pending' && <th scope="col">Accepted On</th>}
                                            {filters.filter === 'reg_progress' && <th scope="col">Started On</th>}
                                            {filters.filter === 'reg_submitted' && <th scope="col">Submitted ON</th>}

                                            <th scope="col">Language</th>
                                            <th scope="col">Reg Status</th>
                                            <th scope="col"></th>
                                        </tr>
                                        </thead>

                                        <tbody>
                                        {response.data?.map((invitation) => (
                                            <tr key={invitation.id}>

                                                {['reg_submitted'].indexOf(filters.filter) > -1 && (
                                                    <td>
                                                        <Form.Check
                                                            key={invitation.id}
                                                            inline
                                                            type="checkbox"
                                                            id={`upload-${invitation.id}`}
                                                            value={invitation.id}
                                                            onChange={e => handleSelectedChange(invitation.id)}
                                                            checked={selected.indexOf(invitation.id) >= 0}
                                                        />
                                                    </td>
                                                )}

                                                <td>{invitation.main_guest?.full_name || invitation.user.full_name}</td>
                                                <td>{invitation.main_guest?.email || invitation.user.email}</td>
                                                <td>{invitation.guest_allowance}</td>
                                                <td>
                                                    {invitation?.wave?.name || '-'}
                                                    {" / "}
                                                    {invitation?.package?.name || '-'}
                                                </td>

                                                {filters.filter === 'reg_pending' && (<td>
                                                    <Moment
                                                        format="DD/MM/YYYY h:mm:ss a"
                                                        date={invitation.metrics.find(m => m.action == 'rsvp_confirmed')?.created_at || invitation.updated_at}/>
                                                </td>)}
                                                {filters.filter === 'reg_progress' && (<td>
                                                    <Moment
                                                        format="DD/MM/YYYY h:mm:ss a"
                                                        date={invitation.metrics.find(m => m.action == 'registration_started')?.created_at || invitation.updated_at}/>
                                                </td>)}
                                                {filters.filter === 'reg_submitted' && (<td>
                                                    <Moment
                                                        format="DD/MM/YYYY h:mm:ss a"
                                                        date={invitation.metrics.find(m => m.action == 'registration_submitted')?.created_at || invitation.updated_at}/>
                                                </td>)}

                                                <td>{invitation.user?.language?.name || '-'}</td>
                                                <td className="text-capitalize">{invitation.registration_status.replace(/_/g, ' ')}</td>
                                                <td>
                                                    <Link to={`/guests/registration/${invitation.id}`}>
                                                        <ChevronRight />
                                                    </Link>
                                                </td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </div>

                                {response.per_page < response.total && (
                                    <Pagination
                                        activePage={response.current_page}
                                        itemsCountPerPage={response.per_page}
                                        totalItemsCount={response.total}
                                        pageRangeDisplayed={5}
                                        itemClass="page-item"
                                        linkClass="page-link"
                                        onChange={loadData}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {selected.length > 0 && (
                <PopupActions>
                    {/* Registration Submitted */}
                    {filters.filter === 'reg_submitted' && (
                        <ConfirmedButton
                            confirmTitle={"Send Pre-Event Email"}
                            confirmText={`You are about to send an pre-event email of ${event.name} to ${selected.length} users. Are you sure you want to proceed? This cannot be undone.`}
                            onClick={sendPreEvent}
                            className="btn btn-secondary btn-xs mr-3">
                            Send Pre Event Email ({selected.length})
                        </ConfirmedButton>
                    )}

                    {/* Pre-Event Email Sent */}
                    {filters.filter === 'pre_event_sent' && (<>
                        <ConfirmedButton
                            confirmTitle={"Send Survey"}
                            confirmText={`You are about to re-send an survey email to the ${event.name} to ${selected.length} users. Are you sure you want to proceed? This cannot be undone.`}
                            onClick={sendSurveys}
                            className="btn btn-secondary btn-xs mr-3">
                            Send Survey ({selected.length})
                        </ConfirmedButton>

                        <ConfirmedButton
                            confirmTitle={"Re-Send Pre-Event Email"}
                            confirmText={`You are about to re-send an pre-event email of ${event.name} to ${selected.length} users. Are you sure you want to proceed? This cannot be undone.`}
                            onClick={sendPreEvent}
                            className="btn btn-secondary btn-xs mr-3">
                            Re-Send Pre Event Email ({selected.length})
                        </ConfirmedButton>
                    </>)}

                    {/* Post-Event Survey Sent */}
                    {filters.filter === 'post_event_survey_sent' && (
                        <ConfirmedButton
                            confirmTitle={"Re-Send Survey"}
                            confirmText={`You are about to re-send an survey email to the ${event.name} to ${selected.length} users. Are you sure you want to proceed? This cannot be undone.`}
                            onClick={sendSurveys}
                            className="btn btn-secondary btn-xs mr-3">
                            Re-Send Survey ({selected.length})
                        </ConfirmedButton>
                    )}
                </PopupActions>
            )}
        </>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminRegistration);
